export default __webpack_public_path__ + "Content/Images/content/checking-account.jpg";